<template>
    <div class="notification-list">
        <div style="text-align: right">
            <el-button style="margin-bottom: 0.2rem" type="primary" @click="markAllAsRead">全部标记为已读</el-button>
        </div>
        <div
            v-for="notification in notifications"
            :key="notification.id"
            :class="['notification-item', { unread: notification.unread }]"
            @click="openNotification(notification)"
        >
            <div class="notification-header">
                <div>
                    <span v-if="!notification.readStatus" class="unread-dot"></span>
                </div>
                <div class="notification-time">{{ getRelativeTime(notification.createTime) }}</div>
            </div>
            <div class="notification-content"><i class="el-icon-bell"
                                                 style="margin-right: 5px"></i>{{ notification.content }}
            </div>

            <div class="notification-actions">
                <el-button v-if="!notification.readStatus" type="text" @click.stop="markAsRead(notification)">标记已读
                </el-button>
                <el-button v-if="notification.messageType === 3 && notification.oprationStatus === 0" type="text"
                           @click.stop="agreeInquiry(notification)">{{ notification.oprationBtuName }}
                </el-button>
                <el-button style="color: #f56c6c;" type="text" @click.stop="deleteNotification(notification)">删除
                </el-button>
            </div>
        </div>

        <div v-if="notifications.length === 0" class="empty-state">
            <i class="fas fa-bell"></i>
            <h3>暂无通知</h3>
            <p>您还没有收到系统通知</p>
        </div>
        <Pagination :currentPage="Number(page)" :pageSizes="[10,20,30,40]"
                    :parentPageSize="Number(size)" :totalNumber="totalNumber"
                    @loadTable="loadTable"></Pagination>
    </div>
</template>

<script>
import Api from '@/components/Api/index.js'
import Pagination from "@/components/Pagination.vue";
import {getRelativeTime} from "@/util/util";

export default {
    name: 'NotificationList',
    components: {Pagination},
    data() {
        return {
            notifications: [],
            page: 1,
            size: 10,
            totalNumber: 0
        }
    },
    methods: {
        markAllAsRead() {
            new Api('oauth').readAllMessage().then(res => {
                if (res.status === 200) {
                    this.notifications.forEach(notification => {
                        this.$set(notification, 'readStatus', 1)
                    });
                    this.$emit('refreshInformation')
                    this.$message.success('所有消息已标记为已读');
                }
            })
        },
        getRelativeTime,
        loadTable(page) {
            this.page = page
            this.getMessageList()
        },
        // 标记单条消息为已读
        markAsRead(notification) {
            new Api('oauth').readMessage({messageId: notification.id}).then(res => {
                if (res.status === 200) {
                    this.$set(notification, 'readStatus', 1)
                    this.$message.success('消息已标记为已读');
                    this.$emit("refreshNumber")
                }
            })
        },
        agreeInquiry(item) {
            new Api('oauth').agreeInquiry({inquiryId: item.oprationId}).then(res => {
                if (res.status === 200) {
                    this.$set(item, 'oprationStatus', 1)
                    this.$set(item, 'readStatus', 1)
                    this.$message.success('接单成功，可在抢单->我抢到的单项询单中查看');
                    this.$emit("refreshNumber")
                } else {
                    this.$message.error('系统异常')
                }
            })
        },
        // 删除消息
        deleteNotification(notification) {
            this.$confirm('确定要删除这条消息吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                new Api('oauth').deleteMessage({messageId: notification.id}).then(res => {
                    if (res.status === 200) {
                        const index = this.notifications.findIndex(item => item.id === notification.id);
                        if (index !== -1) {
                            this.notifications.splice(index, 1);
                        }
                        this.$message.success('消息已删除');
                    }
                })
            }).catch(() => {
                // 用户取消删除
            });
        },
        //获取系统消息列表
        getMessageList() {
            new Api('oauth').getMessageList({page: this.page, size: this.size, q: {}}).then(res => {
                if (res.status === 200) {
                    this.notifications = res.data.records
                    this.totalNumber = Number(res.data.total)
                }
            })
        },
        openNotification(notification) {
            // this.$emit('open-notification', notification)
        }
    },
    mounted() {
        this.getMessageList()
    }
}
</script>

<style scoped>
.notification-list {
    flex: 1;
    overflow-y: auto;
    padding: 10px;
    background-color: #f5f7fa;
}

.notification-item {
    background: #fff;
    padding: 14px 16px;
    border-radius: 6px;
    margin-bottom: 12px;
    transition: box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s;
    border: 1px solid #ebeef5;
    cursor: pointer;
}

.notification-item:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-1px);
    border-color: #dcdfe6;
    background-color: #fff;
}

.notification-item.unread {
    border-left: 3px solid #409EFF;
    background-color: #f5f9ff;
}

.notification-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
}

.unread-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #F56C6C;
}

.notification-time {
    color: #909399;
    font-size: 12px;
    flex-shrink: 0;
}

.notification-content {
    color: #606266;
    font-size: 13px;
    margin-bottom: 10px;
    line-height: 1.6;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.notification-content .el-icon-bell {
    margin-right: 6px;
    margin-top: 2px;
    color: #E6A23C;
    float: left;
}

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 40px;
    color: #7f8c8d;
    text-align: center;
}

.empty-state i {
    font-size: 60px;
    margin-bottom: 20px;
    color: #bdc3c7;
}

.empty-state h3 {
    margin-bottom: 10px;
    color: #2c3e50;
}

.empty-state p {
    color: #95a5a6;
}

.notification-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 4px;
}

.notification-actions .el-button--text {
    padding: 0 2px;
    font-size: 12px;
}

.notification-actions .el-button--text:nth-child(1) {
    color: #409EFF;
}

.notification-actions .el-button--text:nth-child(2) {
    color: #67C23A;
}

.notification-actions .el-button--text:nth-child(3) {
    color: #F56C6C;
}
</style>